import React from "react";
import { createUseStyles, useTheme } from "react-jss";
import useMediaQuery from "../hooks/useMediaQuery";
import { TextFit } from "../textfit/TextFit";
var useStyles = createUseStyles({
    pre: {
        fontFamily: function (_a) {
            var fontFamily = _a.fontFamily;
            return fontFamily !== null && fontFamily !== void 0 ? fontFamily : '"Anova", "Roboto", "Helvetica", "Arial", "sans-serif"';
        },
        whiteSpace: "pre-wrap",
        margin: 0,
        color: function (_a) {
            var color = _a.color;
            return color ? color : "white";
        },
        fontWeight: function (_a) {
            var weight = _a.weight;
            return weight ? weight : 400;
        },
        wordWrap: function (_a) {
            var breakWords = _a.breakWords;
            return breakWords ? "break-words" : "inherit";
        }
    }
});
var UserProvidedText = function (props) {
    var theme = useTheme();
    var children = props.children, className = props.className, maxFont = props.maxFont, color = props.color, weight = props.weight, breakWords = props.breakWords, fontFamily = props.fontFamily, _a = props.fullHeight, fullHeight = _a === void 0 ? true : _a;
    var classes = useStyles({ color: color, weight: weight, breakWords: breakWords, fontFamily: fontFamily });
    var font;
    var isLarge = useMediaQuery(theme.breakpoints.up("lg"));
    var isMedLarge = useMediaQuery(theme.breakpoints.up("md"));
    var isXS = useMediaQuery(theme.breakpoints.down("xs"));
    // if one number provided, max font for all sizes
    if (typeof maxFont === "number") {
        font = maxFont;
        // if array of 2 provided, maxes are [xl, l, m] and [s, xs]
    }
    else if (maxFont.length === 2) {
        if (isMedLarge) {
            font = maxFont[0];
        }
        else {
            font = maxFont[1];
        }
        // if array of 3 provided, maxes are [xl,l], [s,m], [xs]
    }
    else {
        if (isLarge) {
            font = maxFont[0];
        }
        else if (isXS) {
            font = maxFont[2];
        }
        else {
            font = maxFont[1];
        }
    }
    var style = fullHeight ? { height: "100%" } : {};
    return (React.createElement(TextFit, { mode: "multi", max: font, min: 12, className: className, style: style },
        React.createElement("pre", { className: classes.pre }, children)));
};
export default UserProvidedText;
//# sourceMappingURL=UserProvidedText.js.map